import { render, staticRenderFns } from "./TeamLeaderAlertsPanel.vue?vue&type=template&id=089cfd3f&scoped=true&"
import script from "./TeamLeaderAlertsPanel.vue?vue&type=script&lang=js&"
export * from "./TeamLeaderAlertsPanel.vue?vue&type=script&lang=js&"
import style0 from "./TeamLeaderAlertsPanel.vue?vue&type=style&index=0&id=089cfd3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089cfd3f",
  null
  
)

export default component.exports